/**
 * DATABASE MODULE
 */ 
export const START_LOADER = 'START_LOADER'
export const STOP_LOADER = 'STOP_LOADER'

export const GET_DATEPICKER_FR = 'GET_DATEPICKER_FR'

export const GET_CONSTANTS = 'GET_CONSTANTS'